import React from "react";
import Button from "../components/form/Button";
import { Link } from "react-router-dom";
import Image from "../components/elements/Image";
import { useSelector } from "react-redux";

const FrontFooter = () => {
  const { siteSetting } = useSelector((state) => state.setting);
  const socialData = [
    {
      _id: 1,
      name: "Linkedin",
      iconClass: "fa-brands fa-linkedin-in",
      link: "/",
    },
    {
      _id: 2,
      name: "Instagram",
      iconClass: "fa-brands fa-instagram",
      link: "/",
    },
    {
      _id: 3,
      name: "Facebook",
      iconClass: "fa-brands fa-facebook-f",
      link: "/",
    },
    { _id: 4, name: "Twitter", iconClass: "fa-brands fa-x-twitter", link: "/" },
  ];
  return (
    <>
      <section className="relative w-full bg-shades-04">
        <div className="relative bg-shades-02 py-4">
          <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
            <div className="font-medium text-center">
              {siteSetting?.description}
            </div>
          </div>
        </div>
        <div className="relative bg-blue-zodiac">
          <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
            <div className="flex flex-row flex-wrap justify-between sm:flex-nowrap lg:grid grid-cols-3 gap-4 sm:h-12 py-4 sm:py-0">
              <div className="relative flex items-center justify-start order-2 lg:order-1">
                <Link
                  to={"/terms"}
                  className="text-sm xls:text-base xl:text-lg text-white font-CanelaDeck font-bold"
                >
                  Terms & Privacy
                </Link>
              </div>
              <div className="w-full sm:w-auto relative flex items-center justify-center order-1 lg:order-2 mr-auto lg:mr-0">
                <div className="text-sm xls:text-base xl:text-xl text-white font-CanelaDeck font-bold">
                  © {siteSetting?.title}
                </div>
              </div>
              <div className="relative flex items-center justify-end order-3 lg:order-3">
                <div className="flex items-center gap-2 text-sm xls:text-base xl:text-lg text-white font-CanelaDeck font-bold">
                  <div className="relative">Email :</div>
                  <a
                    href="mailto:contact@vpeters.org"
                    className="text-white underline"
                  >
                    {siteSetting?.email}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FrontFooter;
